




































































import { Component, Prop, Vue } from "vue-property-decorator";
import { GeneralCatalogItem } from "@api/models/GeneralCatalogItem";
import { getImageUrl } from "@common/ImageUrlHelper";
import { getBackend } from "@service/router/getters";
import { AppercodeFile } from "@api/models/File";
import { getYouTubeUrl } from "@common/urlHelper";
import { SocialNetworks } from "@share/catalog/enums/SocialNetworks";
import { ContactsTypes } from "@share/catalog/enums/ContactTypes";
import i18n from "@service/locale/i18";

@Component({
    name: "PartnerDescription"
})
export default class PartnerDescription extends Vue {
    @Prop({ required: true }) partner: GeneralCatalogItem;
    @Prop({ required: true }) changes: Record<string, any>;
    @Prop({ required: true }) files: AppercodeFile[];
    @Prop({ default: 'en' }) lang: string;

    partnerToRender: GeneralCatalogItem | null = null;
    socialNetworksClasses: Record<SocialNetworks, string> = {
        [SocialNetworks.linkedin]: 'stand__social-icon_ln',
        [SocialNetworks.facebook]: 'stand__social-icon_f',
        [SocialNetworks.twitter]: 'stand__social-icon_tw',
        [SocialNetworks.instagramm]: 'stand__social-icon_in',
        [SocialNetworks.youtube]: 'stand__social-icon_yt'
    }

    beforeMount() {
        this.partnerToRender = { ...this.partner };
        for (let [propertyName, propertyValue] of Object.entries(this.changes))
        {
            this.$set(this.partnerToRender, propertyName, propertyValue);
        }
    }

    get backend() {
        return getBackend();
    }

    get title()
    {
        return this.partnerToRender?.title ?? '';
    }

    get headerImage() {
        if (this.partnerToRender?.bannerFileId) {
            return getImageUrl(this.backend, this.partnerToRender?.bannerFileId, 1980);
        }
        return '';
    }

    get logoImage()
    {
        if (this.partnerToRender?.iconFileId) {
            return getImageUrl(this.backend, this.partnerToRender?.iconFileId, 512);
        }
        return '';
    }

    get bottomImage() {
        if (this.partnerToRender?.links?.bottomImageFileId) {
            return getImageUrl(this.backend, this.partnerToRender.links.bottomImageFileId, 1980);
        }
        return '';
    }

    get filesToRender()
    {
        if (this.files?.length > 0) {
            return this.files
                .filter(file => !file.isDeleted)
                .map(file => {
                    return {
                        url: getImageUrl(this.backend, file.id, undefined, file.name),
                        name: file.name
                    }
            })
        }

        return [];
    }

    get description() {
        return this.partnerToRender?.webClientDescription ?? '';
    }

    get youTubeLink() {
        const linkToVideo = this.partnerToRender?.links?.linkToVideo;

        return linkToVideo ? getYouTubeUrl(linkToVideo) : '';
    }

    get socialNetworks()
    {
        const result: Array<{class: string; link: string}> = [];
        for (const[socialNetworkKey, socialNetworkClass] of Object.entries(this.socialNetworksClasses)) {
            if (!this.partnerToRender?.links?.[socialNetworkKey]) {
                continue;
            }

            result.push({
                class: socialNetworkClass,
                link: this.partnerToRender.links[socialNetworkKey]
            })
        }

        return result;
    }

    get phoneNumber() {
        return this.getContactByType(ContactsTypes.phoneNumber);
    }

    get email() {
        return this.getContactByType(ContactsTypes.email);
    }

    get site() {
        return this.getContactByType(ContactsTypes.site);
    }

    get siteName() {
        return this.site.replace(/^https?:\/\//, '');
    }

    get address() {
        return this.getContactByType(ContactsTypes.address);
    }

    get hasContacts() {
        return this.phoneNumber || this.email || this.site || this.address;
    }

    get socialNetworksTitle()
    {
        return i18n.t('exhibition.socialNetworksTitle', this.lang).toString();
    }

    get contactsTitle()
    {
        return i18n.t('exhibition.contactsTitle', this.lang).toString();
    }

    getContactByType(type: ContactsTypes) {
        return this.partnerToRender?.links?.[type] ?? '';
    }
}
